import React, { FC, PropsWithChildren } from 'react';
import { Provider } from 'react-redux';
import { store } from 'app/config/storeConfig/storeConfig';

export const StoreProvider: FC<PropsWithChildren> = (props) => {
  return <Provider store={store}>{props.children}</Provider>;
};
